import axios from 'axios'
import { getAuthHeader } from './config'

export const baseURL = '/courses'
const prefixURL = '/api'

const getAllCourses = async (filter = 'published') => {
  const response = await axios.get(`${prefixURL}${baseURL}`, {
    ...getAuthHeader(),
    params: { filter }
  })
  return response.data
}

const getOneCourse = async (courseId) => {
  const response = await axios.get(
    `${prefixURL}${baseURL}/${courseId}`,
    getAuthHeader()
  )
  return response.data
}

const updateCourse = async (courseId, course) => {
  const response = await axios.put(
    `${prefixURL}${baseURL}/${courseId}`,
    course,
    getAuthHeader()
  )
  return response.data
}

const endCourse = async (courseId) => {
  const response = await axios.post(
    `${prefixURL}${baseURL}/${courseId}/end-course`,
    null,
    getAuthHeader()
  )
  return response.data
}

const unArchivedCourse = async (courseId) => {
  const response = await axios.post(
    `${prefixURL}${baseURL}/${courseId}/un-archive`,
    null,
    getAuthHeader()
  )
  return response.data
}

const createCourse = async (course) => {
  const response = await axios.post(
    `${prefixURL}${baseURL}`,
    course,
    getAuthHeader()
  )
  return response.data
}

const deleteCourse = async (courseId) => {
  const response = await axios.delete(
    `${prefixURL}${baseURL}/${courseId}`,
    getAuthHeader()
  )
  return response.data
}

const enrollCourse = async (courseId, userId) => {
  const response = await axios.post(
    `${prefixURL}${baseURL}/${courseId}/enroll`,
    { userId },
    getAuthHeader()
  )
  return response.data
}

const UnenrollCourse = async (courseId, userId) => {
  const response = await axios.post(
    `${prefixURL}${baseURL}/${courseId}/un-enroll`,
    { userId },
    getAuthHeader()
  )
  return response.data
}

const createCourseCertificate = async (courseId, user) => {
  const response = await axios.post(
    `${prefixURL}${baseURL}/${courseId}/certificate`,
    user,
    getAuthHeader()
  )
  return response.data
}

const getCourseCertificates = async (courseId) => {
  const response = await axios.get(
    `${prefixURL}${baseURL}/${courseId}/certificate`,
    getAuthHeader()
  )
  return response.data
}

const courseService = {
  getAllCourses,
  getOneCourse,
  createCourse,
  updateCourse,
  deleteCourse,
  enrollCourse,
  UnenrollCourse,
  endCourse,
  unArchivedCourse,
  createCourseCertificate,
  getCourseCertificates
}
export default courseService
